var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['badge', _vm.badgeSizeClass],style:(_vm.badgeStyle),attrs:{"title":_vm.tooltipTitle}},[_vm._v("\n    "+_vm._s(_vm.status.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }